import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-painspot",
  "use": "icon-icon-painspot-usage",
  "viewBox": "0 0 17.2 17.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.2 17.2\" id=\"icon-icon-painspot\"><defs><style>#icon-icon-painspot .cls-1{fill:#1e1f22;opacity:0.97;}</style></defs><title>资源 1</title><g id=\"icon-icon-painspot_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-painspot_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M1.4,9.9H1.3a1.3,1.3,0,0,1,0-2.6h.1A7.5,7.5,0,0,1,7.3,1.4h0a1.3,1.3,0,0,1,2.6,0h0a7.2,7.2,0,0,1,5.8,5.9h.1a1.3,1.3,0,0,1,1.4,1.3,1.3,1.3,0,0,1-1.4,1.3h-.1a7,7,0,0,1-5.8,5.8h0a1.3,1.3,0,0,1-1.3,1.4,1.3,1.3,0,0,1-1.3-1.4h0A7.2,7.2,0,0,1,1.4,9.9Zm7.2,2.6a3.8,3.8,0,0,0,3.9-3.9,3.9,3.9,0,0,0-3.9-4,4,4,0,0,0-4,4A3.9,3.9,0,0,0,8.6,12.5Zm0-1.3a2.7,2.7,0,1,1,0-5.3h0a2.7,2.7,0,0,1,0,5.3Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-painspot.svg
// module id = N3V0
// module chunks = 75